import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { ModeToggle } from '../theme/mode-toggle.jsx';
import { ActivityService } from './Activity.jsx';
import { logout, useAppDispatch } from '@/store/index.js';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import ProfileIcon from '@/assets/images/authpage/profileIcon.jpg';
import { userEntityType } from '@/utils/Constants';
import useHasClaim from '@/hooks/useHasClaim.jsx';

function Header() {
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state?.auth?.userDetails);

  const { hasClaim } = useHasClaim();
  function formattedDate() {
    const currentDate = new Date();
    const options = {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    };
    const dateParts = currentDate
      .toLocaleDateString('en-GB', options)
      .split(' ');
    return `${dateParts[0]}, ${dateParts[1]} ${dateParts[2]} ${dateParts[3]}`;
  }
  const dispatch = useAppDispatch();

  return (
    <header className="sticky top-0 border-b border-input bg-background z-10 shadow-sm py-3">
      <div className="flex items-center justify-end md:justify-between px-8">
        <div className="hidden md:block">
          <div className="flex flex-col justify-start">
            <span className="text-3xl w-max">
              Hello,{' '}
              {userDetails?.user?.entityType === 'BCA'
                ? userDetails?.isSuperAdmin
                  ? userDetails?.bca?.name
                  : `${userDetails?.user?.firstName} ${userDetails?.user?.lastName}`
                : userDetails?.user?.entityType === 'Company'
                  ? userDetails?.isSuperAdmin
                    ? userDetails?.company?.name
                    : `${userDetails?.user?.firstName} ${userDetails?.user?.lastName}`
                  : 'Admin'}
              👋
            </span>
            <span className="text-secondary-foreground w-max">
              Today is {formattedDate()}
            </span>
          </div>
        </div>
        <div className="flex justify-end items-center gap-5">
          {userDetails?.user?.entityType === userEntityType.Company &&
            userDetails?.company?.coordinatorId && (
              <span>
                Coordinator :{' '}
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger className="hover:cursor-help font-bold">
                      {userDetails?.company?.coordinatorId?.firstName}{' '}
                      {userDetails?.company?.coordinatorId?.lastName}
                    </TooltipTrigger>
                    <TooltipContent className="p-0">
                      <div className="bg-popover text-popover-foreground rounded-lg overflow-hidden min-w-lg">
                        <div className="p-3 space-y-2">
                          <div className="flex gap-2">
                            <span className="text-muted-foreground">Name:</span>
                            <span>
                              {userDetails?.company?.coordinatorId?.firstName}{' '}
                              {userDetails?.company?.coordinatorId?.lastName}
                            </span>
                          </div>
                          <div className="flex gap-2">
                            <span className="text-muted-foreground">
                              Email:
                            </span>
                            <span>
                              {userDetails?.company?.coordinatorId?.email}
                            </span>
                          </div>
                          <div className="flex gap-2">
                            <span className="text-muted-foreground">
                              Phone Number:
                            </span>
                            <span>
                              {userDetails?.company?.coordinatorId?.phoneNumber}
                            </span>
                          </div>
                        </div>
                      </div>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              </span>
            )}
          <ModeToggle />
          {userDetails?.user?.entityType !== 'Vendor' &&
          hasClaim(['read_activity_logs', 'manage_cases']) ? (
            <ActivityService />
          ) : null}
          <div className="flex justify-center items-center">
            <DropdownMenu>
              <DropdownMenuTrigger className="flex items-center outline-none">
                <div
                  className="p-0.5 border-primary border-2 rounded-full"
                  id="profile-icon"
                >
                  <Avatar>
                    <AvatarImage src={ProfileIcon} />
                    <AvatarFallback>CN</AvatarFallback>
                  </Avatar>
                </div>
              </DropdownMenuTrigger>
              <DropdownMenuContent>
                <DropdownMenuLabel>My Account</DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem
                  id="profileItem"
                  onClick={() => navigate('/profile')}
                >
                  Profile
                </DropdownMenuItem>
                {/* <DropdownMenuItem>Setting</DropdownMenuItem> */}
                <DropdownMenuItem
                  className="font-bold"
                  id="logout"
                  onClick={() => {
                    dispatch(logout());
                    navigate('/');
                  }}
                >
                  Logout
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
